import { render } from "./MockupInkboards1.vue?vue&type=template&id=1ec87f4e&scoped=true&ts=true&lang=pug"
import script from "./MockupInkboards1.vue?vue&type=script&lang=ts"
export * from "./MockupInkboards1.vue?vue&type=script&lang=ts"

import "./MockupInkboards1.vue?vue&type=style&index=0&id=1ec87f4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec87f4e"]])

export default __exports__